import React from 'react';
import { Dice5, Spade, Clover, Flame } from 'lucide-react';
import { motion } from 'framer-motion';

const GAME_CATEGORIES = [
  {
    id: 'slots',
    title: 'Slot Oyunlari',
    desc: 'Binlerce farkli slot oyunuyla sansini dene.',
    icon: Dice5,
    color: 'hsl(200, 96%, 60%)'
  },
  {
    id: 'live-casino',
    title: 'Canli Casino',
    desc: 'Gercek krupiyerlerle canli casino deneyimi.',
    icon: Spade,
    color: 'hsl(190, 96%, 52%)'
  },
  {
    id: 'sports',
    title: 'Spor Bahisleri',
    desc: 'Yuksek oranlarla spor bahisleri.',
    icon: Flame,
    color: 'hsl(30, 90%, 55%)'
  },
  {
    id: 'lucky',
    title: 'Sans Oyunlari',
    desc: 'Cark cevirme, kazima kazan ve dahasi.',
    icon: Clover,
    color: 'hsl(140, 70%, 50%)'
  }
];

const Games = () => {
  return (
    <div style={{ padding: '3rem 0' }}>
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title" style={{ fontSize: '2rem' }} data-testid="sans-oyunlari-page-title">Sans Oyunlari</h1>
          <p className="section-subtitle">Partner platformlarimizda bulunan oyun kategorileri</p>
        </motion.div>

        <div className="sponsors-grid">
          {GAME_CATEGORIES.map((cat, idx) => {
            const Icon = cat.icon;
            return (
              <motion.div
                key={cat.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="sponsor-card" style={{ padding: '2rem', textAlign: 'center' }} data-testid={`game-category-card-${cat.id}`}>
                  <div style={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    background: `${cat.color}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem',
                    border: `1px solid ${cat.color}30`
                  }}>
                    <Icon size={28} style={{ color: cat.color }} />
                  </div>
                  <h3 className="sponsor-card-name" style={{ marginBottom: '0.5rem' }}>{cat.title}</h3>
                  <p className="sponsor-card-desc" style={{ marginBottom: '1.25rem' }}>{cat.desc}</p>
                  <div className="sponsor-card-badge">Yakinda</div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Games;
